var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinimize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 5C0.334375 5 2.72908e-07 4.66563 2.36574e-07 4.25C2.00238e-07 3.83437 0.334375 3.5 0.75 3.5L3.5 3.5L3.5 0.75C3.5 0.334375 3.83437 -1.16652e-07 4.25 -1.52988e-07C4.66563 -1.89322e-07 5 0.334375 5 0.75V4.25C5 4.66563 4.66563 5 4.25 5H0.75ZM5 13.25C5 13.6656 4.66563 14 4.25 14C3.83438 14 3.5 13.6656 3.5 13.25L3.5 10.5H0.75C0.334375 10.5 3.10156e-08 10.1656 0 9.75C-3.10156e-08 9.33438 0.334375 9 0.75 9H4.25C4.66563 9 5 9.33438 5 9.75L5 13.25ZM9.75 5C9.33438 5 9 4.66563 9 4.25V0.75C9 0.334375 9.33438 1.89324e-07 9.75 1.52988e-07C10.1656 1.16654e-07 10.5 0.334375 10.5 0.75V3.5L13.25 3.5C13.6656 3.5 14 3.83437 14 4.25C14 4.66563 13.6656 5 13.25 5H9.75ZM10.5 13.25C10.5 13.6656 10.1656 14 9.75 14C9.33438 14 9 13.6656 9 13.25V9.75C9 9.33438 9.33438 9 9.75 9H13.25C13.6656 9 14 9.33438 14 9.75C14 10.1656 13.6656 10.5 13.25 10.5H10.5V13.25Z",
    fill: "#01152E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinimize);
export default __webpack_public_path__ + "static/media/minimize.3c3520889eb90d36c053fcf01b419f2a.svg";
export { ForwardRef as ReactComponent };